import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  id: 1,
  quote: 'Llevaba 12 años atrapado. Probé terapia, apps de bloqueo, grupos de apoyo... nada funcionaba más de 2 semanas. La primera noche que usé el Auxilio 60s sentí algo diferente: el impulso vino, pero por primera vez no me controló. A las 3 semanas ya no necesitaba borrar el historial. Mi esposa notó el cambio antes que yo.',
  author: 'Daniel V.',
  age: 34,
  role: 'Padre de familia, Contador',
  timeUsing: '47 días libre'
}, {
  id: 2,
  quote: 'Soy ingeniero. Pensé que podía resolver esto con lógica y disciplina. Me equivoqué 8 años seguidos. Lo que me enganchó del Protocolo fue que no te pide "ser fuerte", te da un sistema paso a paso. Escuché el audiolibro mientras manejaba al trabajo y apliqué el Mapa de Disparadores esa misma noche. Día 5: primera semana limpia en años. Hoy llevo 2 meses y mi enfoque mental es otro nivel.',
  author: 'Sebastián L.',
  age: 29,
  role: 'Ingeniero de Software',
  timeUsing: '63 días libre'
}, {
  id: 3,
  quote: 'Tenía vergüenza de admitirlo, pero consumía pornografía casi a diario desde los 16. A los 41, mi matrimonio estaba destruido y mi energía por el suelo. Compré el plan completo sin esperar mucho. El audio de Reprogramación Medianoche fue un antes y un después: dormía mejor, los impulsos bajaron drásticamente en la primera semana. Hoy mi esposa dice que "volví a ser el hombre con el que se casó".',
  author: 'Ricardo M.',
  age: 41,
  role: 'Director Comercial, Casado',
  timeUsing: '90+ días libre'
}];
export function Testimonials() {
  return <section className="py-14 px-4 bg-deep-black border-t border-card-border" data-id="element-349">
      <div className="max-w-7xl mx-auto" data-id="element-350">
        <div className="text-center mb-16" data-id="element-351">
          <h2 className="font-bebas text-4xl md:text-5xl text-white mb-4" data-id="element-352">
            EVIDENCIA EN <span className="text-cyan-neon" data-id="element-353">EL CAMPO</span>
          </h2>
          <p className="font-inter text-text-muted max-w-xl mx-auto" data-id="element-354">
            Historias reales de hombres que decidieron blindar su vida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-355">
          {testimonials.map(t => <div key={t.id} className="bg-card-dark border border-cyan-neon/20 rounded-xl p-8 flex flex-col relative overflow-hidden group hover:border-cyan-neon/50 transition-colors duration-300" data-id="element-356">
              <Quote className="w-8 h-8 text-cyan-neon/30 mb-4" data-id="element-357" />

              <div className="flex gap-1 mb-4" data-id="element-358">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-cyan-neon text-cyan-neon" data-id="element-359" />)}
              </div>

              <p className="font-inter text-sm text-gray-300 mb-6 flex-1 leading-relaxed" data-id="element-360">
                "{t.quote}"
              </p>

              <div className="mb-4" data-id="element-361">
                <span className="inline-block bg-cyan-neon/10 border border-cyan-neon/30 text-cyan-neon font-inter text-xs font-semibold px-3 py-1 rounded-full" data-id="element-362">
                  ✅ {t.timeUsing}
                </span>
              </div>

              <div className="flex items-center gap-4 border-t border-card-border pt-6" data-id="element-363">
                <div className="w-10 h-10 rounded-full bg-card-border flex items-center justify-center font-bebas text-xl text-white" data-id="element-364">
                  {t.author.charAt(0)}
                </div>
                <div data-id="element-365">
                  <p className="font-bebas text-xl text-white tracking-wide" data-id="element-366">
                    {t.author}{' '}
                    <span className="text-text-muted text-sm font-inter" data-id="element-367">
                      ({t.age} años)
                    </span>
                  </p>
                  <p className="font-inter text-xs text-cyan-neon uppercase tracking-wider" data-id="element-368">
                    {t.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}